import { Box, Center, Flex, SystemStyleObject } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { colors, pxToRem, TRANSITIONS } from '../../theme';

export const kongActionTooltipStyles: SystemStyleObject = {
  bg: 'backgroundTertiary',
  py: 2,
  px: 3,
  fontWeight: 'medium',
  borderRadius: 'md',
  lineHeight: 'shorter',
  whiteSpace: 'nowrap',
};

export function KongActionsWrapper({
  children,
  styles,
}: PropsWithChildren & {
  styles?: {
    container?: SystemStyleObject;
    body?: SystemStyleObject;
  };
}) {
  return (
    <Box
      position="absolute"
      zIndex={4}
      left="50%"
      bottom={[pxToRem(-115), pxToRem(-145), pxToRem(-200)]}
      transform={`translate(-50%, calc(100% + ${pxToRem(10)}))`}
      {...styles?.container}
    >
      <Flex
        gap={2}
        alignItems="center"
        borderRadius="md"
        h={pxToRem(60)}
        px={3}
        bg="backgroundCardsTransparent"
        css={{
          '& svg': {
            height: pxToRem(21),
            width: 'auto',
          },
          ...styles?.body,
        }}
      >
        {children}
      </Flex>
    </Box>
  );
}

export function KongActionIcon({
  children,
  onClick,
  label,
}: { onClick?: () => void; label: string } & PropsWithChildren) {
  return (
    <Box position="relative" className="group">
      <Center
        onClick={onClick}
        cursor="pointer"
        h={pxToRem(44)}
        px={3}
        borderRadius="sm"
        transition={TRANSITIONS.fast}
        _groupHover={{
          bg: 'rgba(0, 0, 0, 0.15)',
        }}
      >
        {children}
      </Center>
      <Box
        textStyle="p-sm"
        position="absolute"
        bottom={0}
        left="50%"
        transform={`translate(-50%, calc(100% + ${pxToRem(10)}))`}
        display="none"
        _groupHover={{
          display: 'block',
        }}
      >
        <Box
          position="absolute"
          width="0"
          height="0"
          border={`${pxToRem(12)} solid ${colors.backgroundTertiary}`}
          borderTop="none"
          borderLeftColor="transparent"
          borderRightColor="transparent"
          zIndex={1}
          left="50%"
          transform={`translate(-50%, -60%)`}
        />
        <Box css={kongActionTooltipStyles}>{label}</Box>
      </Box>
    </Box>
  );
}
